import { useContext, useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FiCopy, FiCheck } from 'react-icons/fi';
import styles from './CopyToClipboardIcon.module.scss';
import { AlertContext } from '../../context/AlertContext';
import { ALERT_TYPE } from '../../constants';
import messages from '../../utils/helper/messages';

const CopyToClipboardIcon = ({ textToCopy, onCopy, tooltip = "Copy to clipboard" }) => {
    const { showAlert } = useContext(AlertContext);

    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            const copyText = onCopy ? onCopy(...textToCopy) : textToCopy;
            await navigator.clipboard.writeText(copyText);
            setCopied(true);
            setTimeout(() => setCopied(false), 5000);
        } catch (err) {
            showAlert(`${messages.error.prefix} ${err}.`, ALERT_TYPE.ERROR);
        }
    };

    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{copied ? 'Copied!' : tooltip}</Tooltip>}
        >
            <Button
                size="sm"
                variant='link'
                onClick={handleCopy}
                className={`${styles.copyIcon} ${onCopy ? styles.copyGroup : ''} position-absolute`}
            >
                {copied ? <FiCheck className='text-muted' /> : <FiCopy className='text-muted' size={16} />}
            </Button>
        </OverlayTrigger>
    );
};

export default CopyToClipboardIcon;
